<div class="layui-collapse" lay-accordion="">
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">咨询师如何提高收入？</h2>
    <div class="layui-colla-content layui-show">
      <p>
      1.保持在线，主动与其他用户交流。 <br>
      2.完善个人资料，让喜欢你的人对你多一些了解。 <br>
      3.高质量的声音名片，更能吸引别人与你通话哦。<br>
      4.在“个人中心”-“设置”-“接听设置”中设置放电，获得更大曝光。
      </p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">专家如何提高收入？</h2>
    <div class="layui-colla-content">
      <p>
      1.完善个人资料，提高自己的权威性。<br>
      2.在社区分享与您专业领域相关的内容 <br>
      3.提高自己的服务质量，获得用户信赖。<br>
      </p>
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何得到更多的异性网友关注？</h2>
    <div class="layui-colla-content">
      <p>
      1.完善个人资料，让喜欢你的人对你多一些了解。<br>
      2.主动与异性网友发起私信聊天。<br>
      3.多送礼物更容易获得异性好感。<br>
      </p>
    </div>
  </div>
</div>